import { render, staticRenderFns } from "./IdCardDetail.vue?vue&type=template&id=e201a21a&scoped=true&"
import script from "./IdCardDetail.vue?vue&type=script&lang=js&"
export * from "./IdCardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e201a21a",
  null
  
)

export default component.exports